<div class="surface-card p-4 border-round shadow-1" *ngIf="!showCustomerLookup">


  <!-- PAGE HEADER -->
  <div class="text-xl font-semibold mb-1">Global Lookup</div>
  <div class="text-sm text-500 mb-4"></div>

  <!-- SEARCH CRITERIA -->
  <div class="text-lg font-semibold mb-1">Search Criteria</div>
  <div class="text-black-alpha-90 text-sm text-500 mb-3">
    Find customers and orders using any or all of the following:
  </div>

  <div class="flex justify-content-center">
      <!-- CENTERED FORM CONTAINER -->
    <div class="w-full sm:w-10 md:w-8 lg:w-6 xl:w-5">
      <form [formGroup]="businessForm" class="grid">

        <!-- ===== ROW 1 : BUSINESS NAME (LEFT ONLY) ===== -->
        <div class="col-12 md:col-6">
          <label
            for="businessName"
            class="font-semibold mb-1 block"
          >
            Business Name
          </label>
          <input
            id="businessName"
            pInputText
            pKeyFilter="alphanum"
            formControlName="businessName"
            class="w-full"
          />
        </div>

        <!-- EMPTY RIGHT COLUMN -->
        <div class="hidden md:block md:col-6"></div>

        <!-- ===== ROW 2 : FIRST / LAST NAME ===== -->
        <div class="col-12 md:col-6">
          <label
            for="firstName"
            class="font-semibold mb-1 block"
          >
            First Name
          </label>
          <input
            id="firstName"
            pInputText
            pKeyFilter="alpha"
            formControlName="firstName"
            class="w-full"
          />
        </div>

        <div class="col-12 md:col-6">
          <label
            for="lastName"
            class="font-semibold mb-1 block"
          >
            Last Name
          </label>
          <input
            id="lastName"
            pInputText
            pKeyFilter="alpha"
            formControlName="lastName"
            class="w-full"
          />
        </div>

        <!-- ===== ROW 3 : ACCOUNT / ORDER ===== -->
        <div class="col-12 md:col-6">
          <label
            for="accountOrderNumber"
            class="font-semibold mb-1 block"
          >
            Account / Order Number
          </label>
          <input
            id="accountOrderNumber"
            pInputText
            pKeyFilter="alphanum"
            formControlName="accountOrderNumber"
            class="w-full"
          />
        </div>

        <div class="col-12 md:col-6">
          <label
            for="salespersonFullName"
            class="font-semibold mb-1 block"
          >
            Salesperson Full Name
          </label>
          <input
            id="salespersonFullName"
            pInputText
            pKeyFilter="alphanum"
            formControlName="salespersonFullName"
            class="w-full"
          />
        </div>

        <!-- ===== ROW 4 : PHONE (LEFT ONLY) ===== -->
        <div class="col-12 md:col-6">
          <label
            for="phoneNumber"
            class="font-semibold mb-1 block"
          >
            Phone Number
          </label>
          <input
            id="phoneNumber"
            pInputText
            pKeyFilter="int"
            maxlength="10"
            formControlName="phoneNumber"
            class="w-full"
          />
        </div>

        <!-- EMPTY RIGHT COLUMN -->
        <div class="hidden md:block md:col-6"></div>

      </form>
    </div>
  </div>

  <hr class="my-4" />

  <!-- ADVANCED / UNTITLED SECTION -->
  <div class="flex flex-column gap-3">

    <!-- Toggles -->
    <div class="flex gap-5">

      <div class="flex align-items-center gap-2 addusertoggle">
        <p-inputSwitch [(ngModel)]="leadsOnly"></p-inputSwitch>
        <span class="text-sm">Leads Only</span>
      </div>

      <div class="flex align-items-center gap-2 addusertoggle">
        <p-inputSwitch [(ngModel)]="internal"></p-inputSwitch>
        <span class="text-sm">Internal</span>
      </div>

    </div>

    <div class="w-15rem">
      <label class="font-semibold mb-1 block" for="customerType">
        Customer Type
      </label>

      <p-dropdown
        id="customerType"
        [options]="customerTypes"
        optionLabel="label"
        optionValue="value"
        placeholder="Both"
        class="w-full"
        styleClass="p-inputtext-md w-full border-round-md"
        [showClear]="false">
      </p-dropdown>
    </div>

  </div>

    <!-- ACTION BUTTONS -->
    <div class="flex justify-content-end align-items-center gap-4 mt-4">

    <!-- Clear -->
    <button
        pButton
        type="button"
        label="Clear"
        class="p-button-link p-0 text-primary"
        (click)="onClear()">
    </button>

    <!-- Search -->
    <button
        pButton
        type="button"
        label="SEARCH"
        class="p-button-rounded px-5"
        (click)="onSearch()">
    </button>

    </div>

</div>

<!-- SEARCH RESULTS -->
<div class="surface-card p-4 border-round shadow-1 mt-4" *ngIf="showResults && !showCustomerLookup">

  <div class="text-lg font-semibold mb-3">Search Results</div>

  <!-- LOADING STATE -->
  <div
    *ngIf="loading"
    class="flex justify-content-center align-items-center"
    style="min-height: 200px;"
  >
    <p-progressSpinner></p-progressSpinner>
  </div>

  <!-- EMPTY STATE -->
  <div
    *ngIf="!loading "
    class=""
    style="min-height: 200px;"
  >
    <!-- SEARCH RESULTS HEADER -->
    <div class="surface-card p-3 border-round border-1 surface-border mb-3">

      <div class="flex flex-column lg:flex-row lg:align-items-end lg:justify-content-between gap-3">

      <!-- FILTER BY -->
      <div class="flex flex-column gap-1 w-full lg:w-30rem">
        <span class="text-sm font-semibold">Filter By</span>

        <p-multiSelect
          [options]="filterOptions"
          [(ngModel)]="selectedFilters"
          optionLabel="label"
          optionValue="value"
          display="chip"
          background="bg-offer-blue"
          placeholder=""
          class="w-full"
          styleClass="p-inputtext-md border-round-md multiselect-custom"
          [showToggleAll]="false">
        </p-multiSelect>
      </div>

      <!-- RIGHT SIDE -->
      <div class="flex align-items-center gap-4 flex-wrap">

        <!-- Sort By -->
        <div>
          <div class="text-sm font-semibold mb-1">Sort By</div>
          <p-dropdown
            [options]="sortOptions"
            placeholder="Date Added"
            class="w-12rem"
            styleClass="p-inputtext-md">
          </p-dropdown>
        </div>

       </div>
    </div>
    </div>

   <!-- PAGINATION CONTROLS (TOP ONLY – ONE ROW ALWAYS) -->
    <div
      class="flex flex-nowrap align-items-center gap-3 text-sm text-600 w-full mb-4"
    >
      <span class="white-space-nowrap">Results per page</span>

      <p-dropdown
        [options]="pageSizeOptions"
        [(ngModel)]="pageSize"
        optionLabel="label"
        optionValue="value"
        class="w-4rem"
        styleClass="p-inputtext-md"
        (onChange)="onPageSizeChange()">
      </p-dropdown>

      <span class="white-space-nowrap">
        {{ rangeText }}
      </span>

      <!-- PREV -->
      <button
        pButton
        type="button"
        icon="pi pi-chevron-left"
        class="p-button-text p-button-sm"
        [disabled]="isFirstPage"
        (click)="goPrev()">
      </button>

      <!-- NEXT -->
      <button
        pButton
        type="button"
        icon="pi pi-chevron-right"
        class="p-button-text p-button-sm"
        [disabled]="isLastPage"
        (click)="goNext()">
      </button>
    </div>

    <!-- SEARCH RESULTS CARDS -->
    <div class="flex justify-content-center">

      <div class="w-full md:w-10 lg:w-8 xl:w-7">

        <div class="flex flex-column gap-3">

          <div
            *ngFor="let order of paginatedResults"
            class="surface-card border-round border-1 surface-border overflow-hidden"
          >

            <!-- CARD HEADER -->
            <div
              class="flex justify-content-between align-items-center px-3 py-2 text-white sara-header-bg"
            >
              <div class="font-semibold">
                Order {{ order.orderNumber }}
              </div>
              <div class="text-sm">
                Order placed: {{ order.orderPlaced }}
              </div>
            </div>

            <!-- CARD BODY -->
            <div class="p-3 text-sm flex flex-column gap-2">

              <div>
                <span class="font-semibold">Campaign:</span>
                {{ order.campaign }}
                &nbsp;&nbsp;
                <span class="font-semibold">Credit Result:</span>
                {{ order.creditResult }}
              </div>

              <div class="border-1 surface-border border-round p-2">
                <div>
                  <span class="font-semibold">Customer name:</span>
                  <a class="text-primary cursor-pointer">
                    {{ order.customerName }}
                  </a>
                </div>
                <div class="mt-1">
                  <span class="font-semibold">Phone:</span>
                  {{ order.phone }}
                  &nbsp;&nbsp;
                  <span class="font-semibold">Email:</span>
                  {{ order.email }}
                </div>
                <div class="mt-1">
                  <span class="font-semibold">Address:</span>
                  {{ order.address }}
                </div>
              </div>

              <div class="border-1 surface-border border-round p-2">
                <span class="font-semibold">Agent:</span>
                {{ order.agent }}
                &nbsp;&nbsp;
                <span class="font-semibold">Dealer:</span>
                {{ order.dealer }}
              </div>

              <div class="border-1 surface-border border-round p-2">
                <span class="font-semibold">Products Ordered:</span>
                {{ order.products }}
              </div>

              <div class="text-center mt-2">
                <a class="text-primary font-medium cursor-pointer" (click)="customerLookup()">
                  Click to View
                </a>
              </div>

            </div>
          </div>

        </div>

      </div>
    </div>
  </div>

</div>


<app-customer-lookup *ngIf="showCustomerLookup"></app-customer-lookup>